/**
 * CAS 検索アプリ
 */

import $ from 'jquery';
import { TweenMax } from 'gsap';
import Slide from './Slide';
import Filter from './Filter';

const tm = TweenMax;

class CcSearch {
	constructor(root) {
		this.$root = $(root);
		this.$form = this.$root.find('.search-container__input');
		this.$form_reset = this.$root.find('.search-container__icon--close');
		this.$ini_wrap = this.$root.find('.search-ini-wrap');
		this.$ini_selected = this.$root.find('.search-ini-selected');
		this.$ini_close_btn = this.$root.find('.search-close__txt');
		this.$ini_str = this.$root.find('.search-ini__item');
		this.$ini_num = this.$root.find('.search-num__txt');
		this.$ini_alphabet = this.$root.find('.search-alphabet__txt');
		this.$list = this.$root.find('.app-list');
		this.$item = this.$list.find('.app-item');
		this.$search_btn = this.$root.find('.search-btn');
		this.$toast = this.$root.find('.app-toast');
		this.toast_timer = null;
		this.param_url = '';
		this.init();
	}

	/**
	 * 初期処理
	 */
	init() {
		this.slide = new Slide('cc', $('.selected-area'), {
			prev: $('.selected-area__arw--left'),
			next: $('.selected-area__arw--right')
		});
		this.$form.val('');
		this.getData();
		this.addListeners();
	}

	/**
	 * イベント登録
	 */
	addListeners() {
		$(window).on('scroll', $.proxy(this.onScroll, this));
		this.$form.on('keyup', $.proxy(this.inputCheck, this));
		this.$form_reset.on('click', $.proxy(this.formReset, this));
		this.$ini_selected.on('click', $.proxy(this.searchIniOpen, this));
		this.$ini_close_btn.on('click', $.proxy(this.searchIniClose, this));
		this.$ini_str.on('click', $.proxy(this.initialStrClick, this));
		this.$ini_num.on('click', $.proxy(this.initialNumClick, this));
		this.$ini_alphabet.on('click', $.proxy(this.initialAlphabetClick, this));
		this.$search_btn.on('click', $.proxy(this.tracking, this));
		this.$toast.on('click', $.proxy(this.toastHide, this));
		$(document).on('click', '.app-item', $.proxy(this.itemClick, this));
		$(document).on('click', '.selected-delete', $.proxy(this.selectDelete, this));
	}

	/**
	 * jsonデータ取得
	 */
	getData() {
		let url = './load_chemicals.html';
		let option = { method: 'POST', credentials: 'include' };

		if (location.host === 'chemrest.localhost' || location.host === 'localhost' || location.hash.indexOf('mode=develop') > -1) {
			url = '/_develop/chemical.json';
			option = { method: 'GET' };
		}

		fetch(url, option)
			.then(res => {
				return res.json();
			})
			.then(this.loadData.bind(this));
	}

	/**
	 * json読み込み完了
	 */
	loadData(json) {
		this.data = json.data;
		this.filter = new Filter(this.data, ['chemical_name', 'cas_number']);
		this.domCreate(this.data);
	}

	/**
	 * item_dataからDOMを作成追加
	 */
	domCreate(item_data) {
		const selected_data = this.slide.getSetData();

		// 更地に
		this.$list.empty();

		// アイテム作成
		let items = '';
		for (let i = 0, l = item_data.length; i < l; i++) {
			let cls = 'app-item app-item--cc';
			let chemical_name = item_data[i].chemical_name;

			for (let j = 0, k = selected_data.length; j < k; j++) {
				if (item_data[i].cas_number === String(selected_data[j])) cls += ' app-item--selected';
			}

			if (item_data[i].concentration) chemical_name += ` | ${item_data[i].concentration}%`;

			items += `
				<li class="${cls}" data-number="${item_data[i].cas_number}">
					<div class="app-item__inr">
						<p class="app-item__name">${chemical_name}</p>
						<p class="app-item__num">${item_data[i].cas_number}</p>
					</div>
				</li>
			`;
		}

		// flexのスペースアイテムを多めに追加
		for (let i = 0; i < 12; i++) {
			items += `<li class="app-item app-item--space app-item--cc"><div class="app-item__inr"></div></li>`;
		}

		this.$list[0].insertAdjacentHTML('afterbegin', items);

		this.memberUpdate();
	}

	/**
	 * メンバ変数更新
	 */
	memberUpdate() {
		this.$list = this.$root.find('.app-list');
		this.$item = this.$list.find('.app-item');
	}

	/**
	 * スクロール処理
	 */
	onScroll() {
		const header_space = $('.app-header-space');
		const app_header = $('.app-header');
		const top = $(window).scrollTop();
		const scroll_bottom = top + $(window).height();
		const footer = $('.global-footer');

		if (top >= header_space.offset().top) {
			app_header.addClass('app-header--fix');
			header_space.addClass('show');
		} else {
			app_header.removeClass('app-header--fix');
			header_space.removeClass('show');
		}

		if (scroll_bottom >= footer.offset().top) {
			app_header.addClass('app-header--sp-bottom');
		} else {
			app_header.removeClass('app-header--sp-bottom');
		}
	}

	/**
	 * 検索フォーム
	 * @param {*} e
	 */
	inputCheck(e) {
		const _this = $(e.currentTarget);
		let val = _this.val();
		let val_ary = [];

		val_ary = val.split(' ').filter(e => e !== '');

		if (val_ary.length === 0) {
			this.filter.clearVal();
		} else {
			this.filter.addVal(val_ary);
		}

		this.domCreate(this.filter.getResult());
	}

	/**
	 * 検索フォーム初期化
	 */
	formReset() {
		this.$form.val('');
		this.filter.clearVal();
		this.domCreate(this.filter.getResult());
	}

	/**
	 * イニシャルフィルターモーダル開く
	 */
	searchIniOpen() {
		this.$ini_wrap.addClass('search-ini-wrap--show');

		const ini_height = this.$root.find('.search-ini-num').outerHeight() + this.$ini_close_btn.height();
		const margin = $(window).height() / 2 - ini_height / 2;

		tm.set(this.$root.find('.search-ini-num'), { y: margin });
		tm.set(this.$ini_close_btn.parent(), { y: margin });

		tm.to(this.$ini_wrap, 0.5, {
			css: { opacity: 1 }
		});
	}

	/**
	 * イニシャルフィルターモーダル閉じる
	 */
	searchIniClose() {
		tm.to(this.$ini_wrap, 0.5, {
			css: { opacity: 0 },
			onComplete: () => {
				tm.set(this.$ini_wrap, { clearProps: 'opacity' });
				this.$ini_wrap.removeClass('search-ini-wrap--show');
			}
		});
	}

	/**
	 * イニシャルフィルター 文字
	 * @param {*} e
	 */
	initialStrClick(e) {
		const _this = $(e.currentTarget);
		const str = _this.text();

		_this.toggleClass('search-ini__item--current');

		if (_this.hasClass('search-ini__item--current')) {
			this.filter.addInitialStr(str);
		} else {
			this.filter.deleteInitialStr(str);
		}

		this.selectedText();
		this.domCreate(this.filter.getResult());
	}

	/**
	 * イニシャルフィルター 数字
	 * @param {*} e
	 */
	initialNumClick(e) {
		const _this = $(e.currentTarget);
		const str = 'true';

		_this.toggleClass('search-num__txt--current');

		if (_this.hasClass('search-num__txt--current')) {
			this.filter.addInitialNum(str);
		} else {
			this.filter.deleteInitialNum(str);
		}

		this.selectedText();
		this.domCreate(this.filter.getResult());
	}

	/**
	 * イニシャルフィルター 数字
	 * @param {*} e
	 */
	initialAlphabetClick(e) {
		const _this = $(e.currentTarget);
		const str = 'true';

		_this.toggleClass('search-alphabet__txt--current');

		if (_this.hasClass('search-alphabet__txt--current')) {
			this.filter.addInitialAlphabet(str);
		} else {
			this.filter.deleteInitialAlphabet(str);
		}

		this.selectedText();
		this.domCreate(this.filter.getResult());
	}

	/**
	 * スマホの選択済みイニシャル反映
	 */
	selectedText() {
		const set_data = this.filter.getSetData();
		let selected_text = [];

		this.$ini_selected.text('');
		if (set_data.initial_str.size > 0) {
			for (let value of set_data.initial_str.values()) {
				selected_text.push(value);
			}
		}
		selected_text.sort((a, b) => {
			if (a < b) return -1;
			if (a > b) return 1;
			return 0;
		});
		if (set_data.initial_num.size > 0) {
			selected_text.push(this.$ini_num.text());
		}

		this.$ini_selected.text(selected_text.toString());
	}

	/**
	 * 検索ボタンのトラッキング
	 */
	tracking(e) {
		const $_this = $(e.currentTarget);

		if ($_this.attr('href').indexOf('javascript') < 0) {
			const set_data = this.slide.getSetData();
			for (let i = 0, l = set_data.length; i < l; i++) {
				gtag('event', 'search', {
					event_category: 'CAS_SEARCH',
					event_label: set_data[i]
				});
			}
		}
	}

	/**
	 * トーストメッセージ非表示
	 */
	toastHide() {
		tm.killTweensOf(this.$toast);
		tm.to(this.$toast, 0.2, {
			css: { opacity: 0 },
			ease: Power1.easeOut,
			onComplete: function() {
				this.target.removeClass('app-toast--show');
				tm.set(this.target, { clearProps: 'opacity' });
			}
		});
	}

	/**
	 * アイテムのクリック処理
	 * @param {*} e
	 */
	itemClick(e) {
		const _this = $(e.currentTarget);
		const data = _this.data();
		let is_add = false;
		let is_limit = false;

		if (_this.hasClass('app-item--space')) return;

		_this.toggleClass('app-item--selected');

		is_add = _this.hasClass('app-item--selected') ? true : false;
		is_limit = this.slide.getSetData().length >= 10 ? true : false;

		if (is_limit && is_add) {
			_this.removeClass('app-item--selected');
			this.$toast.addClass('app-toast--show');
			clearTimeout(this.toast_timer);
			this.toast_timer = setTimeout($.proxy(this.toastHide, this), 2500);
		}

		for (let i = 0, l = this.$item.length; i < l; i++) {
			const current = this.$item.eq(i);

			if (current.data().number === data.number) {
				if (is_add) {
					if (!is_limit) current.addClass('app-item--selected');
				} else {
					current.removeClass('app-item--selected');
				}
			}
		}

		if (_this.hasClass('app-item--selected')) {
			if (!is_limit) this.slide.addList(data.number);
		} else {
			this.slide.deleteList(data.number);
		}

		const set_data = this.slide.getSetData();
		this.param_url = '../result/?';
		for (let i = 0, l = set_data.length; i < l; i++) {
			this.param_url += `cas_number[]=${set_data[i]}&`;
		}
		this.param_url = this.param_url.substring(0, this.param_url.length - 1);

		this.$search_btn.attr('href', this.param_url);
	}

	/**
	 * 選択済み削除
	 * @param {*} e
	 */
	selectDelete(e) {
		const _this = $(e.currentTarget);
		const data = _this.data();

		for (let i = 0, l = this.$item.length; i < l; i++) {
			const current = this.$item.eq(i);

			if (current.data().number === data.number) {
				current.removeClass('app-item--selected');
			}
		}

		this.slide.deleteList(data.number);
	}
}

export default CcSearch;



// WEBPACK FOOTER //
// ./src/js/app/CcSearch.js